// extracted by mini-css-extract-plugin
export default {"badge":"OfficialBadge_badge__yUBK1","official":"OfficialBadge_official__rHGBZ","homebrew":"OfficialBadge_homebrew__Dey2S","standalone":"OfficialBadge_standalone__uYgVx"};